import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flags/ru",
  "use": "flags/ru-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 12\" id=\"flags/ru\">\n    <path fill=\"#fff\" d=\"M0 0h18v4H0z\" />\n    <path fill=\"#5282FF\" d=\"M0 4h18v4H0z\" />\n    <path fill=\"#FF5050\" d=\"M0 8h18v4H0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol